import React from "react";
import BlogList from "../../components/Blog/BlogList";
import Blogs from "../../components/Blog/blog";

import ruinsImg from '../../assets/images/Home/ruins.png'
import lakeImg from '../../assets/images/Home/lake.png'
import Footer from "../../components/Layout/Footer/Footer";
import { Link } from "react-router-dom";

export default function Blog () {

    return (
        <main className='main'>
            <div className="blog-background">
                <div className="blog-contaner">
                    <h2 className="block-container-title">
                        Our News & Blog
                    </h2>
                   <div className="blog-cards-row">
                    <Link to='/western-sahra-gaming-license-blog' className="blog-item-element">
                        <div className="">
                            <div className="blog-img-wrapper">
                                <img src={ruinsImg} />
                            </div>
                            <h3 className="blog-item-title">
                                Why Western Sahara Is Emerging as a Strategic Jurisdiction for Gaming Licenses
                            </h3>
                            <div className="blog-item-descr-wrapper">
                                <p className="blog-item-descr">
                                    Discover why Western Sahara is becoming a new hub for iGaming licenses...
                                </p>
                            </div>
                            <div className="aditional-content">
                                <div className="blog-item-date">
                                    2025.10.01
                                </div>
                                <button className="contact-us-black-button">
                                    Read more
                                    
                                </button>
                            </div>
                        </div>
                    </Link>
                    <Link to='/anjouan-gaming-license-blog' className="blog-item-element">
                    <div className="">
                        <div className="blog-img-wrapper">
                            <img src={lakeImg} />
                        </div>
                        <h3 className="blog-item-title">
                            Why the Anjouan Gaming License Is Gaining Momentum in the iGaming World
                        </h3>
                        <div className="blog-item-descr-wrapper">
                            <p className="blog-item-descr">
                                Malta Gaming Authority is recognized worldwide for iGaming licenses...
                            </p>
                        </div>
                        <div className="aditional-content">
                            <div className="blog-item-date">
                                2025.10.01
                            </div>
                            <button className="black-btn">
                                Read more
                            </button>
                        </div>
                    </div>
                    </Link>
                </div>
                </div>
            </div>
            {/* <Footer /> */}
        </main>
    )
}